import { SiteLayout } from '../components/site/SiteLayout';
import { Eyebrow } from '../components/site/PageHero';
import { ReasonsCarousel } from '../components/site/ReasonsCarousel';
import { PhoneButton } from '../components/site/PhoneButton';

export default function WhyChooseUs() {
  return (
    <SiteLayout testid="why-choose-us-page">
      <section className="max-w-7xl mx-auto px-5 lg:px-8 pt-16 md:pt-24 pb-24 space-y-12">
        <div className="max-w-3xl space-y-6">
          <div className="rise-in"><Eyebrow>Why Choose Us</Eyebrow></div>
          <h1 className="rise-in font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight" style={{ animationDelay: '80ms' }}>
            5 great reasons to choose <span className="text-orange-400">Zivae Financial</span>
          </h1>
          <p className="rise-in text-base md:text-lg text-slate-300" style={{ animationDelay: '160ms' }}>Why families trust us with their retirement planning.</p>
        </div>
        <ReasonsCarousel />
        <div className="flex flex-wrap gap-3">
          <PhoneButton type="financial" size="lg" testid="why-phone-financial" />
          <PhoneButton type="medicare" size="lg" testid="why-phone-medicare" />
        </div>
      </section>
    </SiteLayout>
  );
}
